(function() {
	'use strict';

	angular.module('requestApp', [ 'corePRUGAGreatApp', 'ngTable','ui.select','ngSanitize']);
})();
